module.exports = __webpack_public_path__ + "img/sello-eco.0b4fc69a.png";